import { baseApi } from "../baseApi";
import { StatMoneymapRequest, StatMoneymapResponse } from "./types";

export const statMoneymapApi = (body: StatMoneymapRequest) =>
  baseApi<StatMoneymapResponse, StatMoneymapRequest>({ url: "/api/m/stat/moneymap", method: "POST", body });
